import { useUIVersion } from '@/utils/UIVersionContext'
import classNames from 'classnames'

import { Avatar, AvatarFallback } from '../ui/avatar'

interface Props {
  fullName: string
  style?: {}
  bigText?: boolean
  textStyle?: {}
}

const UserAvatar: React.FC<Props> = (props) => {
  const { fullName } = props
  const { isNewUI } = useUIVersion()

  let splitUserName
  if (!fullName) {
    splitUserName = ['J', 'D']
  } else {
    splitUserName = fullName.split(' ')
  }
  const name =
    splitUserName.length > 1
      ? splitUserName[0].charAt(0).toUpperCase() + splitUserName[1].charAt(0).toUpperCase()
      : splitUserName[0].charAt(0).toUpperCase() + splitUserName[0].charAt(1).toUpperCase()

  if (isNewUI) {
    return (
      <Avatar className='w-29.5 h-29.5'>
        {/* <AvatarImage src='' /> */}
        <AvatarFallback className='bg-[#1677ff] text-white font-bold text-3xl'>
          {name}
        </AvatarFallback>
      </Avatar>
    )
  }

  return (
    <div className={'avatar-text'} style={props.style}>
      <span className={classNames(props.bigText ? 'avatar-text__big' : '')} style={props.textStyle}>
        {name}
      </span>
    </div>
  )
}

export default UserAvatar
